<template>
  <div>
    <van-row class="payFoot">
      <!-- 单独购买/发起拼团 -->
      <van-col
        :span="24"
        class="text-c"
        v-if="classDetial.status == 2 && !classDetial.ifSoldOut"
      >
        <div v-if="classDetial.acttypeid == 3">
          <van-button
            class="xz-button-info signUp m-t-045 m-r-075 b-r-013"
            style="color: #fc7d15; width: 40%; background: white"
            @click="goPay(0)"
          >
            <p style="color: #fc7d15">¥{{ classDetial.courseOriginal }}</p>
            <p style="color: #fc7d15">
              {{ classDetial.acttypeid == 3 ? "单独报名" : "立即购买" }}
            </p>
          </van-button>
          <van-button
            type="danger"
            v-if="classDetial.acttypeid == 3"
            class="xz-button-info playGroup m-t-045 b-r-013"
            style="width: 40%"
            @click="goPay()"
          >
            <p>¥{{ classDetial.coursePrice }}</p>
            <p>
              {{
                belongGroupId != ""
                  ? "参与拼团"
                  : "发起" + classDetial.pinNum + "人拼团"
              }}
            </p>
          </van-button>
        </div>
        <div v-else>
          <div class="f-l-l m-l-08">
            <p class="colorF1 f-s-10 text-l m-t-05">
              ¥{{ classDetial.courseOriginal }}
            </p>
            <p class="f-s-7 colorF2">{{ classDetial.courseXnum }}人购买</p>
          </div>
          <div class="f-l-r m-r-8" style="width: 7.5rem" @click="goPay(0)">
            <van-button
              style="width: 100%"
              class="xz-button-info playGroup m-t-045 m-r-075 b-r-013"
              @click="goPay(0)"
            >
              <p style="color: white">立即购买</p>
            </van-button>
          </div>
          <div class="f-l-r m-r-075" @click="customerClick">
            <van-icon name="comment-o" class="m-t-07 colorF1 f-s-10" />
            <p class="f-s-5 colorF2">客服</p>
          </div>
        </div>
      </van-col>
      <van-col
        :span="24"
        class="text-c"
        v-if="classDetial.status == 3 && !classDetial.ifSoldOut"
      >
        <van-share-sheet
          v-model="showShare"
          title="邀请好友"
          :options="options"
          @select="share"
        />
        <p class="f-l-l f-s-16 m-l-1" style="line-height: 70px">
          还差<span style="color: #fd7b11"
            >{{ classDetial.differNumberpeople }}人</span
          >成团
        </p>
        <van-button
          type="danger"
          class="xz-button-info playGroup m-t-045 b-r-013 f-l-r m-r-075"
          style="width: 40%"
          @click="inviteFriends"
        >
          <p>邀请好友</p>
        </van-button>
      </van-col>

      <van-col
        :span="24"
        v-if="classDetial.status == 1 && !classDetial.ifSoldOut"
        class="text-c"
      >
        <van-button
          type="danger"
          class="xz-button-info playGroup m-t-045 b-r-013"
          style="width: 98%"
          @click="goLookClass"
        >
          <p>去看课</p>
        </van-button>
      </van-col>

      <van-col :span="24" v-if="classDetial.ifSoldOut" class="text-c">
        <van-button
          type="info"
          class="m-t-045 b-r-013"
          style="width: 98%; background: #888; color: white; border: none"
          @click="goLookClass"
          disabled
        >
          <p>已售罄</p>
        </van-button>
      </van-col>
    </van-row>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop style="z-index: 99999999999999">
        <!-- <div class="block" /> -->
        <van-image :src="Invite" class="Invite f-l-r"></van-image>
      </div>
    </van-overlay>
    <Agreement ref="agreement" :cid="cid" />
  </div>
</template>

<script>
/* eslint-disable */

import { getAppClient } from "@/utils/commonUtils";
import { getWxConfig } from "@/model/pay/payServer";
import Agreement from "@/components/common/agreement/agreement"

export default {
  props: {
    classDetial: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components:{
    Agreement
  },
  data() {
    return {
      showShare: false,
      options: [
        [
          { name: "微信", icon: "wechat" },
          { name: "朋友圈", icon: "wechat-moments" },
          //   { name: "微博", icon: "weibo" },
          //   { name: "QQ", icon: "qq" },
        ],
        [
          { name: "复制链接", icon: "link", className: "Url" },
          // { name: "分享海报", icon: "poster" },
          // { name: "二维码", icon: "qrcode" },
          // { name: "小程序码", icon: "weapp-qrcode" },
        ],
      ],
      Invite: require("@/assets/imgs/weChat/Invite.png"),
      show: false,
      cid:""
    };
  },
  methods: {
    // 去看课
    goLookClass() {
      let data = {
        cid : this.classDetial.cid,
        uid : this.uid()
      }
      this.ApiNew.Mine.userIfSignAgreement(data).then(res => {
        if(res.retuCode == 5000) {
          this.$router.push({
            path: "/chapter",
            query: {
              cid: this.classDetial.cid,
            },
          });
        } else if(res.retuCode == 5022 || res.retuCode == 5023) { // 用户未签署协议
          this.cid = this.classDetial.cid
          this.$refs.agreement.agreementName = res.data.name
          this.$refs.agreement.agreementId = res.data.agreementid
          this.$refs.agreement.show = true
        }
      }).catch(() => {
        this.$router.push({
          path: "/chapter",
          query: {
            cid: this.classDetial.cid,
          },
        });
      })
     
    },
    // 分享到微信好友
    WxShare() {
      if (getAppClient() == "JSAPI") {
        this.showShare = false;
        this.show = true;
      } else {
        this.copyUrl();
        window.location.href = "weixin://";
      }
    },
    // 点击分享
    share(Option) {
      switch (Option.name) {
        case "微信":
          this.WxShare();
          break;
        case "朋友圈":
          this.WxShare();
          break;
        case "复制链接":
          this.copyUrl();
          break;
      }
    },
    copyUrl() {
      let oInput = document.createElement("input");
      oInput.value = this.shareUrl;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$toast({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },
    inviteFriends() {
      this.shareWx()
      this.showShare = true;
    },
    shareWx() {
      let data = {
        url: encodeURIComponent(location.href.split("#")[0]),
        appId: this.GLOBAL.wxPay.appid,
      };
      getWxConfig(data).then((res) => {
        let money = this.classDetial.courseOriginal;
        let title = "老铁，就差你啦~助我免费领BIM资料！";
        let desc = "我正在0元抢BIM课程，点链接参与活动，你也能领取一份哦！";
        if (money != 0) {
          title = "老铁，就差你啦~助我抢BIM资料！";
          desc = "我正在超低价抢BIM课程，点链接参与活动，你也能领取一份哦！";
        }
        let data = res.data;
        let _that = this;
        if (data && data.timeStamp) {
          window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: this.GLOBAL.wxPay.appid, // 必填，公众号的唯一标识
            timestamp: data.timeStamp, // 必填，生成签名的时间戳
            nonceStr: data.nonce_str, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: [
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "checkJsApi",
              "updateTimelineShareData",
              "updateAppMessageShareData",
              "hideMenuItems",
              "chooseImage",
              "uploadImage",
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
            if (wx.updateAppMessageShareData) {
              wx.updateAppMessageShareData({
                title, // 分享标题
                desc, // 分享描述
                link: _that.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:
                  "http://webxiaozhu.oss-cn-beijing.aliyuncs.com/images/xiaozhup7tMHh", // 分享图标
                success: function (res) {
                  // alert("分享成功1");
                },
                cancel: function (res) {
                  alert("失败");
                  // 用户取消分享后执行的回调函数
                },
              });
            } else {
              wx.onMenuShareAppMessage({
                title, // 分享标题
                desc, // 分享描述
                link: _that.shareUrl.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:
                  "http://webxiaozhu.oss-cn-beijing.aliyuncs.com/images/xiaozhup7tMHh", // 分享图标
                success: function (res) {
                  alert("分享成功2");
                },
                cancel: function (res) {
                  alert("失败");
                  // 用户取消分享后执行的回调函数
                },
              });
            }
            wx.updateTimelineShareData({
              title, // 分享标题
              desc, // 分享描述
              link: _that.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl:
                "http://webxiaozhu.oss-cn-beijing.aliyuncs.com/images/xiaozhup7tMHh", // 分享图标
              success: function (res) {
                // alert("分享成功2");
              },
              cancel: function (res) {
                alert("失败");
                // 用户取消分享后执行的回调函数
              },
            });
            wx.error(function (res) {
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              alert("errorMSG:" + JSON.stringify(res));
            });
          });
        }
      });
    },
    goPay(type) {
      let belongGroupId = this.$route.query.belongGroupId;

      if (localStorage.getItem("setToken") == null) {
        this.goLogin();
      } else {
        this.$router.push({
          path: "/classPay",
          query: {
            cid: this.classDetial.cid,
            acttypeid: type != undefined ? type : this.classDetial.acttypeid,
            belongGroupId: belongGroupId != undefined ? belongGroupId : "",
          },
        });
      }
    },
  },
  computed: {
    shareUrl() {
      let query = this.$route.query;
      let belongGroupId = this.classDetial.orderGroupId;
      let uid = JSON.parse(localStorage.getItem("userInfo")).uid;
      if (belongGroupId == null || query.belongGroupId != undefined) {
        return window.location.href + "&uid=" + uid;
      } else {
        return (
          window.location.href +
          "&belongGroupId=" +
          belongGroupId +
          "&uid=" +
          uid
        );
      }
    },
    belongGroupId() {
      let belongGroupId = this.$route.query.belongGroupId;
      if (
        belongGroupId == null ||
        belongGroupId == undefined ||
        belongGroupId == ""
      ) {
        return "";
      } else {
        return belongGroupId;
      }
    },
  },
};
</script>

<style scoped>
.Invite {
  width: 50%;
}
.payFoot {
  height: 3.5rem;
  background-color: white;
  box-shadow: 0rem -0.1rem 0.2rem 0rem rgba(0, 0, 0, 0.08);
}
</style>